import React from 'react';
import BWAccordion from 'components/shared/BWAccordion/index';
import FormNumber from 'components/shared/BWFormControl/FormNumber';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import FormItem from 'components/shared/BWFormControl/FormItem';
import { monthOptions } from 'pages/Promotions/utils/helpers';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import CouponProductGift from 'pages/Coupon/components/add/CouponProductGift';
import { COUPON_PRODUCT_TYPE } from 'pages/Coupon/utils/constants';
import { DEFFEND_KEY_GET, DEFFEND_KEY_SET, getValueByField } from '../../utils/helpers';
import { ARRAY_DEFEND_CONDITION_PROMOTION, ARRAY_DEFEND_CONDITION_PROMOTION_BY_KEY } from '../../utils/constants';

const DisplayBlock = styled.label`
  display: block;
`;

const ConditionGrid = styled.div`
  display: grid;
  gap: 12px;
`;

const ConditionCard = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 0.9fr) minmax(0, 1.1fr);
  gap: 16px;
  align-items: start;
  padding: 14px 16px;
  border: 1px solid #e4e9f1;
  border-radius: 10px;
  background: #fff;

  .bw_promotion_condition_title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .bw_promotion_condition_title strong {
    display: block;
    color: #1d2939;
    font-size: 15px;
    line-height: 22px;
  }

  .bw_promotion_condition_title small {
    display: block;
    margin-top: 2px;
    color: #667085;
    font-size: 13px;
    line-height: 18px;
  }

  .bw_promotion_condition_fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .bw_promotion_condition_fields_full {
    grid-column: 1 / -1;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const ComboNote = styled.div`
  padding: 12px 14px;
  border: 1px solid #fedf89;
  border-radius: 10px;
  background: #fffbeb;
  color: #7a4b00;
  font-size: 13px;
  line-height: 20px;
`;

const PromotionsCondition = ({ disabled }) => {
  const methods = useFormContext();
  const canUseComboPromotion = true;

  React.useEffect(() => {
    const legacyQuantityValue = methods.getValues('is_promorion_by_total_quantity');
    if (legacyQuantityValue !== undefined && methods.getValues('is_promotion_by_total_quantity') === undefined) {
      methods.setValue('is_promotion_by_total_quantity', legacyQuantityValue);
    }
  }, [methods]);

  const handleAndCheckConditionPromotion = (field, value) => {
    const cloneDefffendArray = structuredClone(ARRAY_DEFEND_CONDITION_PROMOTION);
    const shortDef = structuredClone(ARRAY_DEFEND_CONDITION_PROMOTION_BY_KEY);
    let arrValueDefffendArray = [];
    cloneDefffendArray?.map((val, index) => {
      if (val) {
        let result = null;
        if (field && val === field) {
          result = getValueByField(methods, field, value, DEFFEND_KEY_SET);
        } else {
          result = getValueByField(methods, val, null, DEFFEND_KEY_GET);
        }

        if (!result) {
          methods.unregister(shortDef[`${val}`]['fieldOne'], {});
          if (shortDef[`${val}`]['fieldTwo']) {
            methods.unregister(shortDef[`${val}`]['fieldTwo'], {});
          }
        } else {
          methods.register(shortDef[`${val}`]['fieldOne'], { required: 'Trường bắt buộc' });
          if (shortDef[val]['fieldTwo']) {
            methods.register(shortDef[`${val}`]['fieldTwo'], { required: 'Trường bắt buộc' });
          }
        }
        arrValueDefffendArray.push(result);
      }
    });

    // let checkConditionPro = checkArgumentsArr(arrValueDefffendArray);
    // if(checkConditionPro) {
    //   methods.setValue('check_condition', 1);
    // } else {
    //   methods.setValue('check_condition', null);
    // }
  };

  return (
    <BWAccordion title='Điều kiện khuyến mại'>
      <ConditionGrid>
        <ConditionCard>
          <div className='bw_promotion_condition_title'>
            <label className='bw_checkbox'>
              <input
                disabled={disabled}
                checked={methods.watch('is_promotion_by_price')}
                type='checkbox'
                onChange={(e) => {
                  handleAndCheckConditionPromotion('is_promotion_by_price', e.target.checked);
                }}
              />
              <span></span>
            </label>
            <div>
              <strong>Theo mức giá sản phẩm</strong>
              <small>Áp dụng khi giá từng sản phẩm trong đơn nằm trong khoảng khai báo.</small>
            </div>
          </div>
          {Boolean(methods.watch('is_promotion_by_price')) && (
            <div className='bw_promotion_condition_fields'>
              <FormNumber field='from_price' addonAfter='VNĐ' bordered disabled={disabled} placeholder='Từ giá' />
              <FormNumber field='to_price' addonAfter='VNĐ' bordered disabled={disabled} placeholder='Đến giá' />
            </div>
          )}
        </ConditionCard>
        <ConditionCard>
          <div className='bw_promotion_condition_title'>
            <label className='bw_checkbox'>
              <input
                disabled={disabled}
                checked={methods.watch('is_promotion_by_total_money')}
                type='checkbox'
                onChange={(e) => {
                  handleAndCheckConditionPromotion('is_promotion_by_total_money', e.target.checked);
                }}
              />
              <span></span>
            </label>
            <div>
              <strong>Theo tổng tiền đơn hàng</strong>
              <small>Áp dụng khi tổng tiền hàng trước ưu đãi nằm trong khoảng tối thiểu/tối đa.</small>
            </div>
          </div>
          {Boolean(methods.watch('is_promotion_by_total_money')) && (
            <div className='bw_promotion_condition_fields'>
              <FormNumber
                field='min_promotion_total_money'
                addonAfter='VNĐ'
                bordered
                disabled={disabled}
                placeholder='Tối thiểu'
              />
              <FormNumber
                field='max_promotion_total_money'
                addonAfter='VNĐ'
                bordered
                disabled={disabled}
                placeholder='Tối đa'
              />
            </div>
          )}
        </ConditionCard>
        <ConditionCard>
          <div className='bw_promotion_condition_title'>
            <label className='bw_checkbox'>
              <input
                disabled={disabled}
                checked={methods.watch('is_promotion_by_total_quantity')}
                type='checkbox'
                onChange={(e) => {
                  handleAndCheckConditionPromotion('is_promotion_by_total_quantity', e.target.checked);
                }}
              />
              <span></span>
            </label>
            <div>
              <strong>Theo số lượng mua</strong>
              <small>Áp dụng khi tổng số lượng sản phẩm hợp lệ đạt khoảng số lượng khai báo.</small>
            </div>
          </div>
          {Boolean(methods.watch('is_promotion_by_total_quantity')) && (
            <div className='bw_promotion_condition_fields'>
              <FormNumber field='min_promotion_total_quantity' bordered disabled={disabled} placeholder='Tối thiểu' />
              <FormNumber field='max_promotion_total_quantity' bordered disabled={disabled} placeholder='Tối đa' />
            </div>
          )}
        </ConditionCard>
        <ConditionCard>
          <div className='bw_promotion_condition_title'>
            <label className='bw_checkbox'>
              <input
                disabled={disabled || !canUseComboPromotion}
                checked={methods.watch('is_combo_promotion')}
                type='checkbox'
                onChange={(e) => {
                  const checked = e.target.checked ? 1 : 0;
                  methods.setValue('is_combo_promotion', checked);
                  if (checked) {
                    methods.setValue('is_all_product', 0);
                    methods.setValue('type_apply_product', COUPON_PRODUCT_TYPE.APPOINT);
                  } else {
                    methods.setValue('combo_apply_list', []);
                    methods.setValue('check_combo_apply', '');
                    methods.setValue(
                      'product_list',
                      (methods.watch('product_list') || []).filter((product) => !product?.from_combo_id),
                    );
                  }
                }}
              />
              <span></span>
            </label>
            <div>
              <strong>Combo/bộ sản phẩm</strong>
              <small>Đơn hàng phải có đủ các sản phẩm hoặc đủ các ngành hàng đã chọn mới được hưởng ưu đãi.</small>
            </div>
          </div>
          <ComboNote>
            {canUseComboPromotion
              ? 'Dùng cho chương trình mua theo bộ, ví dụ loa + amply + micro. Nếu tắt, chỉ cần một sản phẩm/ngành hàng trong danh sách thỏa điều kiện.'
              : 'Combo chỉ có hiệu lực khi chương trình không áp dụng cho tất cả sản phẩm và tất cả ngành hàng.'}
          </ComboNote>
        </ConditionCard>
      </ConditionGrid>
      <div className='bw_col_12 bw_flex bw_align_items_center bw_mt_1'>
        <div className='bw_col_12'>
          <CouponProductGift disabled={disabled} />
        </div>
      </div>
      <div className='bw_col_12 bw_flex bw_align_items_center bw_mt_1'>
        <div className='bw_col_12'>
          <label className='bw_checkbox'>
            <input
              disabled={disabled}
              checked={methods.watch('is_promorion_by_apply_birthday')}
              type='checkbox'
              onChange={(e) => {
                handleAndCheckConditionPromotion('is_promorion_by_apply_birthday', e.target.checked);
              }}
            />
            <span></span> Khuyến mại theo sinh nhật khách hàng
          </label>
        </div>
        {Boolean(methods.watch('is_promorion_by_apply_birthday')) && (
          <>
            <div className='bw_col_12'>
              <DisplayBlock className='bw_mt_1 bw_mb_1'>
                Chọn tháng sinh nhật sẽ áp dụng chương trình khuyến mại <span className='bw_red'> *</span>
              </DisplayBlock>
              <FormItem hiddenLabel={true} label='Chọn tháng'>
                <FormSelect disabled={disabled} mode='multiple' field='apply_birthday_list' list={monthOptions} />
              </FormItem>
            </div>
          </>
        )}

        {/* <FormInput type='hidden' field='check_condition'         
          validation={{
            required: 'Điều kiện khuyến mãi là bắt buộc',
          }}
        /> */}
      </div>
    </BWAccordion>
  );
};

export default PromotionsCondition;
